import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading"); // loading | ok | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!token) {
      setState("error");
      setMsg("No verification token was provided.");
      return;
    }
    api.post("/auth/verify-email", { token })
      .then(({ data }) => { setState("ok"); setMsg(data.message); })
      .catch((e) => { setState("error"); setMsg(e.response?.data?.detail || "Verification failed."); });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-2xl shadow-sm p-8 text-center" data-testid="verify-email-card">
        {state === "loading" && (
          <><Loader2 className="mx-auto text-slate-400 animate-spin" size={40} /><p className="mt-4 text-slate-600">Verifying your email…</p></>
        )}
        {state === "ok" && (
          <>
            <CheckCircle2 className="mx-auto text-emerald-500" size={48} />
            <h2 className="mt-4 text-xl font-bold text-slate-900">Email verified</h2>
            <p className="mt-2 text-sm text-slate-500">{msg}</p>
            <Link to="/login" data-testid="verify-to-login" className="inline-block mt-6 h-10 px-6 leading-10 rounded-md bg-slate-900 text-white text-sm font-medium">Continue to sign in</Link>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="mx-auto text-red-500" size={48} />
            <h2 className="mt-4 text-xl font-bold text-slate-900">Verification failed</h2>
            <p className="mt-2 text-sm text-slate-500">{msg}</p>
            <Link to="/login" className="inline-block mt-6 text-blue-600 hover:underline text-sm">Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
